import {deepCopyArray} from "../Types/arrayUtilities";
import {isString} from "../Types/typeUtilities";
import type {OrderResult} from "./sortFactory";

export function dynamicSort(property: string, SortDescending = false, baseProperty = ""): (a: Record<string, unknown>, b: Record<string, unknown>) => number {
    let sortOrder = SortDescending ? -1 : 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function(a, b) {
        let result = 0;
        const aProp = isString(a[property]) ? (a[property] as string).toLowerCase() : a[property] as string | number;
        const bProp = isString(b[property]) ? (b[property] as string).toLowerCase() : b[property] as string | number;
        if (aProp === bProp && baseProperty !== "") {
            const aBaseProp = isString(a[baseProperty]) ? (a[baseProperty] as string).toLowerCase() : a[baseProperty] as string | number;
            const bBaseProp = isString(b[baseProperty]) ? (b[baseProperty] as string).toLowerCase() : b[baseProperty] as string | number;
            result = (aBaseProp < bBaseProp) ? -1 : (aBaseProp > bBaseProp) ? 1 : 0;
        }
        else
            result = (aProp < bProp) ? -1 : (aProp > bProp) ? 1 : 0;
        return result * sortOrder;
    };
}

export function updateOrder<T>(orderResults: OrderResult): T[] {
    let listToSort = deepCopyArray(orderResults.listToSort) as T[];
    const [removed] = listToSort.splice(orderResults.startIndex, 1);
    listToSort.splice(orderResults.endIndex, 0, removed);

    return listToSort;
}

export function convertToSortedIds(orderResults: { id: string }[]): string[] {
    return orderResults.map((result) => result.id);
}
